import SocialLoginContainer from "./SocialLoginContainer";
import SocialLoginStore from "./SocialLoginStore";

export default SocialLoginStore(SocialLoginContainer);
